"use client"

import { PhoneCall } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `PhoneCallIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const PhoneCallIcon = component(Icon)({ as: PhoneCall })
